import request from "@/utils/request";
// 根据来源和类型查询消息模板
export const getMessageTemplateBySourceAndType = (source, type) =>
  request({
    url: "/api/message/workMessage/template/type",
    method: "get",
    params: {source: source, type: type}
  });
